import { Link } from "react-router-dom";

type WhatsNewLinkProps = {
  readonly hasUnread: boolean;
  readonly className: string;
};

const WhatsNewLink = ({ hasUnread, className }: WhatsNewLinkProps) => (
  <Link
    to="/whats-new"
    aria-label={hasUnread ? "What’s new, unread updates available" : "What’s new"}
    className={className}
  >
    <span>What’s new</span>
    {hasUnread ? (
      <span
        aria-hidden="true"
        className="rounded-full bg-emerald-700 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white"
      >
        New
      </span>
    ) : null}
  </Link>
);

export default WhatsNewLink;
